import React, { useState } from 'react';
import { Users, Plus, Minus, Check } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const PassengerCountCard = ({ onSelect, initialCount = 1 }: any) => {
  const { t } = useTranslation();
  const [count, setCount] = useState(initialCount);

  const handleIncrement = () => {
    const newCount = Math.min(count + 1, 50);
    setCount(newCount);
    onSelect(newCount);
  };

  const handleDecrement = () => {
    const newCount = Math.max(count - 1, 1);
    setCount(newCount);
    onSelect(newCount);
  };

  const handleDirectInput = (e: any) => {
    const value = parseInt(e.target.value) || 1;
    const newCount = Math.max(1, Math.min(value, 50));
    setCount(newCount);
    onSelect(newCount);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="mb-4"
    >
      <div className="relative group">
        <div className="absolute -inset-0.5 bg-gradient-to-r from-orange-600 to-amber-600 rounded-2xl blur opacity-30 group-hover:opacity-50 transition duration-300"></div>
        
        <div className="relative bg-background dark:bg-slate-800 rounded-2xl p-4 border border-border dark:border-slate-700">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-orange-500 to-amber-500 flex items-center justify-center">
                <Users size={20} className="text-white" />
              </div>
              <div>
                <h4 className="font-semibold text-foreground dark:text-slate-200">Number of passengers</h4>
                <p className="text-xs text-muted-foreground">{t('passengerCountCard.hvorMangeSkalReise', 'Hvor mange skal reise?')}</p>
              </div>
            </div>
            {count > 0 && (
              <div className="w-8 h-8 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center">
                <Check size={16} className="text-green-600 dark:text-green-400" />
              </div>
            )}
          </div>

          <div className="flex items-center justify-center space-x-4">
            <button
              onClick={handleDecrement}
              disabled={count <= 1}
              className="w-12 h-12 rounded-xl bg-gradient-to-br from-slate-100 to-slate-200 dark:from-slate-700 dark:to-slate-600 flex items-center justify-center hover:scale-105 active:scale-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
            >
              <Minus size={20} className="text-foreground dark:text-slate-300" />
            </button>

            <div className="flex-1 max-w-[120px]">
              <input
                type="number"
                value={count}
                onChange={handleDirectInput}
                min="1"
                max="50"
                className="w-full text-center text-3xl font-bold bg-muted/50 dark:bg-slate-900/50 border-2 border-border dark:border-slate-700 rounded-xl py-3 text-foreground dark:text-slate-200 focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
              />
            </div>

            <button
              onClick={handleIncrement}
              disabled={count >= 50}
              className="w-12 h-12 rounded-xl bg-gradient-to-br from-orange-500 to-amber-500 flex items-center justify-center hover:scale-105 active:scale-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 shadow-lg shadow-orange-500/30"
            >
              <Plus size={20} className="text-white" />
            </button>
          </div>

          <div className="mt-3 p-3 bg-orange-50 dark:bg-orange-900/20 rounded-xl text-center">
            <p className="text-sm text-orange-800 dark:text-orange-300">
              {count === 1 ? '1 passenger' : `${count} passengers`}
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default PassengerCountCard;
